<template>
  <div class="open_table">
    <div class="title">
      Hours of Operation
    </div>
    <div class="mon">Mon:</div>
    <div class="mon">{{convert_to_time(store.open_time_mon)}}</div>
    <div class="mon">-</div>
    <div class="mon">{{convert_to_time(store.close_time_mon)}}</div>
    <div></div>
    <div class="tue">Tue:</div>
    <div class="tue">{{convert_to_time(store.open_time_tue)}}</div>
    <div class="tue">-</div>
    <div class="tue">{{convert_to_time(store.close_time_tue)}}</div>
    <div></div>
    <div class="wed">Wed:</div>
    <div class="wed">{{convert_to_time(store.open_time_wed)}}</div>
    <div class="wed">-</div>
    <div class="wed">{{convert_to_time(store.close_time_wed)}}</div>
    <div></div>
    <div class="thu">Thu:</div>
    <div class="thu">{{convert_to_time(store.open_time_thu)}}</div>
    <div class="thu">-</div>
    <div class="thu">{{convert_to_time(store.close_time_thu)}}</div>
    <div></div>
    <div class="fri">Fri:</div>
    <div class="fri">{{convert_to_time(store.open_time_fri)}}</div>
    <div class="fri">-</div>
    <div class="fri">{{convert_to_time(store.close_time_fri)}}</div>
    <div></div>
    <div class="sat">Sat:</div>
    <div class="sat">{{convert_to_time(store.open_time_sat)}}</div>
    <div class="sat">-</div>
    <div class="sat">{{convert_to_time(store.close_time_sat)}}</div>
    <div></div>
    <div>Sun:</div>
    <div>{{convert_to_time(store.open_time_sun)}}</div>
    <div>-</div>
    <div>{{convert_to_time(store.close_time_sun)}}</div>
    <div></div>
  </div>

</template>

<script>
  import {mapGetters} from "vuex";

  const moment = require('moment-timezone')

  export default {
    name: "StoreOpenTable",
    props: ['store'],
    computed: {},
    mounted() {
      this.weekday()
    },
    methods: {
      weekday() {
        let weekday = moment.tz(this.store.timezone).format("ddd").toLowerCase()
        let myElements = document.querySelectorAll('.' + weekday);
        for (let i = 0; i < myElements.length; i++) {
          myElements[i].classList.add("active");
        }
      },
      convert_to_time(time_in_minutes) {

        var ap = [' AM', ' PM']; // AM-PM
        var hh = Math.floor(time_in_minutes / 60); // getting hours of day in 0-24 format
        var mm = (time_in_minutes % 60); // getting minutes of the hour in 0-55 format
        var str = ("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
        return str.replace(/00:/,'12:')
      },
    }
  }
</script>

<style scoped lang="scss">
  .open_table {
    display: grid;
    grid-template-columns: auto auto auto auto 1fr;
    grid-column-gap: 1rem;

    .title {
      margin-bottom: 24px;
      color: black;
      grid-column-end: span 5;
    }
  }

  .active {
    font-weight: 600;
    color: var(--v-primary-base);
  }


</style>



// WEBPACK FOOTER //
// src/Elements/StoreOpenTable.vue